const SELECTED_COMPANY_ID_KEY = 'selectedCompanyId';
const SELECTED_COMPANY_NAME_KEY = 'selectedCompanyName';
const LEGACY_PLATFORM_TOKEN_KEY = 'platformAuthToken';

export const DEFAULT_COMPANY_ID = 0;
export const ADMIN_PATH = '/admin';
export const MAPS_PATH = '/maps';

/** Supervisor JWT lives in memory only — never written to localStorage. */
let platformAuthTokenMemory = null;

export const isDefaultCompanyId = (companyId) => {
  if (companyId == null || companyId === '') {
    return false;
  }

  return Number(companyId) === DEFAULT_COMPANY_ID;
};

export const getCompanyRecordId = (company) => {
  const id =
    company?.company_id ??
    company?.companyId ??
    company?.fk_company_id ??
    company?.fkCompanyId ??
    company?.id;
  if (id == null || id === '') {
    return null;
  }

  const parsed = Number(id);
  return Number.isFinite(parsed) ? parsed : null;
};

export const getSelectedCompanyId = () => {
  const stored = localStorage.getItem(SELECTED_COMPANY_ID_KEY);
  if (stored == null || stored === '') {
    return null;
  }

  const id = Number(stored);
  if (!Number.isInteger(id) || id <= 0) {
    return null;
  }

  return id;
};

export const getSelectedCompanyName = () =>
  localStorage.getItem(SELECTED_COMPANY_NAME_KEY) || null;

export const setSelectedCompany = (companyId, companyName) => {
  const id = Number(companyId);
  if (!Number.isInteger(id) || id <= 0) {
    return;
  }

  localStorage.setItem(SELECTED_COMPANY_ID_KEY, String(id));
  if (companyName) {
    localStorage.setItem(SELECTED_COMPANY_NAME_KEY, String(companyName));
  } else {
    localStorage.removeItem(SELECTED_COMPANY_NAME_KEY);
  }
};

export const getPlatformAuthToken = () => platformAuthTokenMemory;

export const setPlatformAuthToken = (token) => {
  platformAuthTokenMemory = token || null;
};

export const clearCompanySession = () => {
  platformAuthTokenMemory = null;
  localStorage.removeItem(SELECTED_COMPANY_ID_KEY);
  localStorage.removeItem(SELECTED_COMPANY_NAME_KEY);
  localStorage.removeItem(LEGACY_PLATFORM_TOKEN_KEY);
};

export const getHomePath = ({ isPlatformSupervisor, isInCompanyContext }) =>
  isPlatformSupervisor && !isInCompanyContext ? ADMIN_PATH : MAPS_PATH;
